module.exports = __webpack_public_path__ + "img/532ff4ef6c239d9319468c94993d34d8.png";